import { useCallback, useState } from 'react';
import monitoring from '../common/libs/monitoring';
import useApiClient from './useApiClient';

/**
 * 検索履歴に関するHooks
 */
export function useSearchHistoryKeywords() {
  const { apiClient } = useApiClient();

  const [searchHistoryKeywords, setSearchHistoryKeywords] = useState<string[]>(
    [],
  );

  const clearSearchHistoryKeywords = useCallback(() => {
    setSearchHistoryKeywords([]);
  }, []);

  const removeSearchHistoryKeywords = useCallback((keyword: string) => {
    setSearchHistoryKeywords((keywords) =>
      keywords.filter((k) => k !== keyword),
    );
  }, []);

  const fetchSearchHistoryKeywords = useCallback(async () => {
    try {
      const res = await apiClient(`/api/search-keyword/history`, {
        method: 'GET',
      });
      if (res.ok) {
        const data = await res.json();
        setSearchHistoryKeywords(data);
      } else {
        throw new Error();
      }
    } catch (e) {
      monitoring.notify({
        name: `API ERROR DETECTED ${e}`,
        message: '検索履歴の取得に失敗しました。',
      });
    }
  }, [apiClient]);

  const deleteSearchHistoryKeywords = useCallback(
    async (keyword: string) => {
      removeSearchHistoryKeywords(keyword);

      try {
        const res = await apiClient(
          `/api/search-keyword/history?keyword=${encodeURIComponent(keyword)}`,
          {
            method: 'DELETE',
          },
        );
        if (!res.ok) {
          throw new Error();
        }
      } catch (e) {
        monitoring.notify({
          name: `API ERROR DETECTED ${e}`,
          message: '検索履歴の削除に失敗しました。',
        });
      }
    },
    [apiClient, removeSearchHistoryKeywords],
  );

  return {
    searchHistoryKeywords,
    clearSearchHistoryKeywords,
    fetchSearchHistoryKeywords,
    deleteSearchHistoryKeywords,
  };
}
